import React, { useEffect, useState, useRef } from "react";
import { Auth, Hub } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib/types";
import BtnGoogleNormal from "./google/btn_google_signin_dark_normal_web@2x.png";
import BtnGoogleDisabled from "./google/btn_google_signin_dark_disabled_web@2x.png";

enum UserState {
  SIGNED_OUT = "signedOut",
  SIGNED_IN = "signedIn",
  LOADING = "loading",
}

const LoginButtons = ({ disabled = false }) => (
  <div>
    <input
      disabled={disabled}
      type="image"
      alt="Sign in with Google"
      src={disabled ? BtnGoogleDisabled : BtnGoogleNormal}
      width="200"
      onClick={() => Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google })}
    />
  </div>
);

export const SignInGoogle = ({ onSignedIn = () => {} }) => {
  const isActive = useRef(true);
  const [user, setUser] = useState(null);
  const [userState, setUserState] = useState(UserState.LOADING);

  async function checkUser() {
    if (UserState.SIGNED_IN === userState) {
      // console.log("Found user, not going to check again.");
      return;
    }

    if (UserState.SIGNED_OUT === userState) {
      // console.log("Signed out, not going to check user.");
      return;
    }

    await Auth.currentAuthenticatedUser()
      .then((currentUser) => {
        // console.log("currentAuthenticatedUser:", { currentUser });
        if (isActive.current) setUser(currentUser);
        if (isActive.current) setUserState(UserState.SIGNED_IN);
      })
      .catch(() => {
        // console.error("currentAuthenticatedUser", { error });
        if (isActive.current) setUserState(UserState.SIGNED_OUT);
      });
  }

  useEffect(() => {
    Hub.listen("auth", () => {
      if (isActive.current) setUserState(UserState.LOADING);
      checkUser();
    });
    checkUser();

    return () => {
      Hub.remove("auth", () => {});
      isActive.current = false;
    };
  });

  if (user) {
    onSignedIn();
    return <LoginButtons disabled />;
  }

  return <LoginButtons />;
};
